const styles = theme => {
    return {
        root: {
            marginTop: theme.root.marginTop,
            paddingBottom: theme.root.paddingBottom,
            background: '#f9f9f9',
            minHeight: '100vh'
        },
        container: {
            maxWidth: 960,
            margin: 'auto',
            [theme.breakpoints.up(600)]: {
                paddingLeft: 16,
                paddingRight: 16
            }
        },
        appBar: {
            position: 'relative'
        },
        layout: {
            width: 'auto',
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            [theme.breakpoints.up(600)]: {
                width: 600,
                marginLeft: 'auto',
                marginRight: 'auto'
            }
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            //maxWidth: '570px',
            //margin: '0px auto',
            position: 'relative',
            background: theme.paper ? theme.paper.background : '#f9f9f9',
            padding: theme.spacing(2),
            paddingBottom: theme.spacing(1) + 'px!important',
            paddingTop: theme.paper ? theme.paper.paddingTop : theme.spacing(3) + 'px!important',
            minHeight: '98vh',
            [theme.breakpoints.up(600)]: {
                minHeight: '826px',
                padding: theme.spacing(4),
                paddingTop: theme.spacing(4) + 'px!important',
                paddingBottom: theme.spacing(1) + 'px!important'
            },
            borderTopColor: theme.palette.primaryColor,
            boxShadow: theme.paper ? theme.paper.boxShadow : null,
            marginBottom: theme.paper ? theme.paper.marginBottom : theme.spacing(3),
            borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        },
        simpleWrapper: {},
        stepperContainer: {
            maxWidth: '570px',
            padding: 0,
            margin: '0px auto',
            [theme.breakpoints.up(600)]: {
                padding: '0 16px'
            }
        },
        fullScreenPaper: {
            position: 'absolute',
            top: 60
        },
        loader: {
            position: 'absolute',
            bottom: '0',
            width: '100%',
            left: '0',
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            zIndex: 10,
            height: 2
        },
        progressBarRoot: {
            background: '#ffffff'
        },
        progressBarBar: {
            background: theme.palette.primaryColor
        },
        stepper: {
            padding: `0 0 ${theme.spacing(3)}px`
        },
        buttons: {
            display: 'block',
            //justifyContent: 'flex-end',
            paddingTop: theme.spacing(4),
            background: theme.pagination ? theme.pagination.background : 'transparent',
            position: theme.pagination ? theme.pagination.position : 'inherit',
            padding: theme.pagination ? theme.pagination.padding : null,
            bottom: theme.pagination ? theme.pagination.bottom : null,
            width: theme.pagination ? theme.pagination.width : null
        },
        button: {
            marginTop: theme.spacing(3),
            marginLeft: theme.spacing(1)
        },
        bottomNavigation: {
            width: '100%',
            position: 'fixed',
            bottom: 0,
            zIndex: 1,
            borderTop: '1px solid #cccccc;'
        },
        fullscreenToggle: {
            top: '-10px',
            left: '50%',
            zIndex: '20',
            position: 'absolute',
            marginLeft: '-10px',
            boxShadow: '0 0px 5px rgba(0, 0, 0, 0.25)',
            background: '#f9f9f9',
            width: '20px',
            height: '20px',
            minHeight: '20px'
        },
        backButton: {
            display: 'block',
            margin: 'auto',
            color: theme.backButton ? theme.backButton.color : 'rgba(0, 0, 0, 0.5)',
            marginTop: theme.backButton ? theme.backButton.marginTop : 7,
            marginBottom: theme.backButton ? theme.backButton.marginBottom : 30,
            width: theme.backButton ? theme.backButton.width : null,
            maxWidth: theme.backButton ? theme.backButton.maxWidth : null,
            borderRadius: theme.borderRadius ? theme.backButton.borderRadius : 10
        },
        twoButtonsBackButton: {
            //marginLeft: theme.spacing.unit * 2,
            [theme.breakpoints.up(600)]: {
                //marginLeft: theme.spacing.unit * 4,
            }
        },
        forwardButton: {
            display: 'block',
            margin: 'auto',
            //marginRight: theme.spacing.unit * 2,
            [theme.breakpoints.up(600)]: {
                //marginRight: theme.spacing.unit * 4,
            },
            padding: '8px 28px',
            boxShadow: theme.forwardButton ? theme.forwardButton.boxShadow : null,
            color: theme.forwardButton ? theme.forwardButton.color : null,
            borderRadius: theme.forwardButton ? theme.forwardButton.borderRadius : 20,
            width: theme.forwardButton ? theme.forwardButton.width : null,
            maxWidth: theme.forwardButton ? theme.forwardButton.maxWidth : null,
            background: theme.forwardButton ? theme.forwardButton.background : null,
            marginTop: theme.forwardButton ? theme.forwardButton.marginTop : 0,
            marginBottom: theme.forwardButton ? theme.forwardButton.marginBottom : theme.spacing(2)
        },
        rightIcon: {
            marginLeft: theme.spacing(1),
            marginRight: -theme.spacing(1) * 0.5
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: '0 8px',
            ...theme.mixins.toolbar,
            justifyContent: 'center',
            textAlign: 'center',
            marginBottom: -20
        },
        logoText: {
            fontSize: '26px',
            marginLeft: '8px',
            textTransform: 'uppercase'
        },
        hideOnMobile: {
            [theme.breakpoints.down(600)]: {
                display: 'none'
            }
        },
        infoCardWrapper: {
            paddingLeft: 32
        }
    }
}

export {styles}
